export const getSelector = (el) => {
  if (el.id) return `#${el.id}`;

  const getNthOfType = (node) => {
    if (!node || !node.parentElement) return 1;
    const tag = node.tagName;
    const siblings = Array.from(node.parentElement.children).filter(
      (child) => child.tagName === tag
    );
    return siblings.indexOf(node) + 1;
  };

  const parts = [];
  let node = el;
  while (node && node.nodeType === 1) {
    const tag = node.tagName.toLowerCase();
    if (tag === "html" || tag === "body") break;
    let part = tag;

    if (node.className && typeof node.className === "string") {
      const firstClass = node.className.trim().split(/\s+/)[0];
      if (firstClass) part += `.${firstClass}`;
    }

    const nth = getNthOfType(node);
    part += `:nth-of-type(${nth})`;
    parts.unshift(part);

    if (node.parentElement?.id) {
      parts.unshift(`#${node.parentElement.id}`);
      break;
    }
    node = node.parentElement;
  }

  if (parts.length > 0) return parts.join(" > ");
  return el.tagName ? el.tagName.toLowerCase() : "";
};

export const rgbToHex = (rgb) => {
  if (!rgb || rgb === "transparent") return "#ffffff";
  const normalized = rgb.replace(/\s+/g, "").toLowerCase();
  if (normalized === "rgba(0,0,0,0)") return "#ffffff";
  const rgbaMatch = normalized.match(/^rgba\((\d+),(\d+),(\d+),([0-9.]+)\)$/);
  if (rgbaMatch && Number(rgbaMatch[4]) === 0) return "#ffffff";
  const v = rgb.match(/\d+/g);
  return v
    ? "#" +
        v
          .slice(0, 3)
          .map((x) => parseInt(x, 10).toString(16).padStart(2, "0"))
          .join("")
    : "#ffffff";
};
